import { ApplicationRef, createComponent, EnvironmentInjector, Injector } from "@angular/core";
import { MentionBoxClass } from "@common/ux/html-editor/html-editor-froala/html-editor-froala.component";
import { DisplayMentionPersonComponent } from "./display-mention-person/display-mention-person.component";


export function attachMentionPersonPopover(injector: Injector, editorElement: HTMLElement) {
    new MentionPersonPopover(injector, editorElement).processText();
}

class MentionPersonPopover {
    private applicationRef: ApplicationRef;
    private environmentInjector: EnvironmentInjector;

    public constructor(
        injector: Injector,
        private editorElement: HTMLElement,
    ) {
        this.applicationRef = injector.get(ApplicationRef);
        this.environmentInjector = injector.get(EnvironmentInjector);
    }

    public async processText() {
        const walker = this.editorElement.ownerDocument.createTreeWalker(this.editorElement, NodeFilter.SHOW_TEXT, (node) =>
            node.parentElement?.classList.contains(MentionBoxClass)
                ? NodeFilter.FILTER_ACCEPT
                : NodeFilter.FILTER_SKIP,
        );

        // need to walk all nodes first, cannot modify while walking
        const nodesToProcess = new Set<Node>();
        while (walker.nextNode()) {
            nodesToProcess.add(walker.currentNode);
        }

        for (const node of nodesToProcess) {
            await this.addDisplayMentionPersonComponentToNode(node);
        }
    }

    private async addDisplayMentionPersonComponentToNode(node: Node) {
        const parentElement = node.parentElement;
        if (parentElement?.parentNode) {
            const personIdString = parentElement.dataset.mentionPersonId;
            if (personIdString) {
                const mentionPersonId = parseInt(personIdString);
                if (!isNaN(mentionPersonId)) {
                    const componentRef = this.createDisplayMentionPersonComponentRef(mentionPersonId);
                    this.applicationRef.attachView(componentRef.hostView);
                    parentElement.parentNode.replaceChild(componentRef.location.nativeElement, parentElement);
                }
            }
        }
    }

    private createDisplayMentionPersonComponentRef(mentionPersonId: number) {
        const componentRef = createComponent(DisplayMentionPersonComponent, { environmentInjector: this.environmentInjector });
        componentRef.setInput("personId", mentionPersonId);
        return componentRef;
    }
}
